const BUGS_MESSAGE =
  "please raise a bug ticket by clicking on the 'Report a Bug' button in the top right corner or by navigating to the Navigator Bugs Service Desk portal to resolve this issue.";

export function bugsMessage(baseMessage?: string): string {
  if (!baseMessage) {
    return BUGS_MESSAGE.charAt(0).toUpperCase() + BUGS_MESSAGE.slice(1);
  }
  return `${baseMessage} ${BUGS_MESSAGE}`;
}
